import { render } from "./Footer.vue?vue&type=template&id=3366ccd8&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"

import "./Footer.vue?vue&type=style&index=0&id=3366ccd8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3366ccd8"

export default script